(function () {
  'use strict';

  function normalize(value) {
    return value.toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function displayedText(element) {
    var copy = element.cloneNode(true);
    copy.querySelectorAll('p, li, br, div, h2, h3, h4').forEach(function (block) {
      block.before(' ');
      block.after(' ');
    });
    return normalize(copy.textContent);
  }

  function init(root) {
    if (root.dataset.faqReady) return;
    var controls = root.querySelector('[data-faq-controls]');
    var search = root.querySelector('[data-faq-search]');
    var clear = root.querySelector('[data-faq-clear]');
    var count = root.querySelector('[data-faq-count]');
    var empty = root.querySelector('[data-faq-empty]');
    if (!controls || !search || !clear || !count || !empty) return;
    var categories = Array.from(root.querySelectorAll('[data-faq-category]')).map(function (category) {
      return {
        element: category,
        items: Array.from(category.querySelectorAll('[data-faq-item]')).map(function (item) {
          return { element: item, text: displayedText(item) };
        })
      };
    });

    function update() {
      var query = normalize(search.value);
      var matches = 0;
      categories.forEach(function (category) {
        var visibleInCategory = 0;
        category.items.forEach(function (item) {
          var visible = !query || item.text.includes(query);
          item.element.hidden = !visible;
          if (visible) visibleInCategory++;
        });
        category.element.hidden = visibleInCategory === 0;
        matches += visibleInCategory;
      });
      count.textContent = root.dataset.faqCountTemplate.replace('__COUNT__', String(matches));
      empty.hidden = matches !== 0;
    }

    search.addEventListener('input', update);
    clear.addEventListener('click', function () {
      search.value = '';
      update();
      search.focus();
    });
    update();
    root.dataset.faqReady = 'true';
    controls.hidden = false;
  }

  function initAll() { document.querySelectorAll('[data-faq-root]').forEach(init); }
  initAll();
  document.addEventListener('shopify:section:load', initAll);
}());
